import { useEffect } from 'react';

import { Mediator } from '@spotahome/soyuz-mediator';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';

import {
  ExtendedLandlordInformationModal as ExtendedLandlordInformationModalComponent,
  useModalHandle,
  MediaQuery
} from '@spotahome/ui-library';

import { SHOW_EXTENDED_LANDLORD_INFORMATION } from '@spotahome/marketplace-common/src/channels';

import { useLandlordInformation } from '../../context/LandlordInformationContext';

const { isMobileScreen, isPhabletScreen, isTabletScreen } = MediaQuery;

const ExtendedLandlordInformationModal = () => {
  const { isModalOpen, handleModalOpen, handleModalClose } = useModalHandle();
  const { landlordInformation } = useLandlordInformation();

  const handleDesktopLandlordTypeClick = () => {
    const llSection = document.querySelector(
      '[data-sticky-in-navigation="aboutLandlord"]'
    );
    window.scrollTo({
      top: llSection.getBoundingClientRect().top + window.scrollY - 70, // extra height for top navigation
      behavior: 'smooth'
    });
  };

  const handleLandlordTypeClick = () => {
    SoyuzAnalytics.sendGA4Event('ll-info-preview-click-value-proposition', {});
    if (isMobileScreen() || isPhabletScreen() || isTabletScreen()) {
      handleModalOpen();
    } else {
      handleDesktopLandlordTypeClick();
    }
  };

  useEffect(() => {
    Mediator.subscribe(
      SHOW_EXTENDED_LANDLORD_INFORMATION,
      handleLandlordTypeClick
    );

    return () =>
      Mediator.unsubscribe(
        SHOW_EXTENDED_LANDLORD_INFORMATION,
        handleLandlordTypeClick
      );
  }, []);

  return isModalOpen && landlordInformation ? (
    <ExtendedLandlordInformationModalComponent
      landlordInformation={landlordInformation}
      isOpen={isModalOpen}
      onClose={handleModalClose}
    />
  ) : null;
};

export default ExtendedLandlordInformationModal;
